import { League } from '../models';
import { LeagueRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class GetPublicLeaguesUseCase {
  constructor(private leagueRepository: LeagueRepository) {}

  async execute(limit = 20, offset = 0): Promise<League[]> {
    logger.debug('GetPublicLeagues', 'Fetching public leagues', { limit, offset });

    const leagues = await this.leagueRepository.getPublicLeagues(limit, offset);

    logger.debug('GetPublicLeagues', 'Public leagues fetched', { count: leagues.length });

    return leagues;
  }
}
